import React from 'react'

const CC = () => {
  return (
    <div>
        <h1><center>Coming Soon...</center></h1>
    </div>
  )
}

export default CC